import { create } from "zustand";
import { devtools, createJSONStorage, persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

// 页面数据和滚动位置缓存
type PageCache = {
  [key: string]: {
    data?: any;
    scrollPosition?: { x: number; y: number };
  };
};

type State = {
  pageCache: PageCache;
  userInfo: any;
  statusBarHeight: number;
};

type Action = {
  setPageCache: (values: PageCache) => void;
  getPageCache: () => PageCache;
  setUserInfo: (value: any) => void;
  setStatusBarHeight: (value: number) => void;
};

export const useAppStore = create<State & Action>()(
  devtools(
    persist(
      immer((set, get) => ({
        pageCache: {},
        userInfo: {},
        statusBarHeight: 0,
        setPageCache: (values) => {
          set((state) => {
            state.pageCache = {
              ...state.pageCache,
              ...values,
            };
          });
        },
        getPageCache: () => {
          return get().pageCache;
        },
        setUserInfo: (value: any) => {
          set((state) => {
            state.userInfo = value;
          });
        },
        setStatusBarHeight: (value: number) => {
          set((state) => {
            state.statusBarHeight = value;
          });
        },
      })),
      {
        name: "app-store",
        storage: createJSONStorage(() => sessionStorage),
      }
    )
  )
);

export const getUserInfo = () => {
  return useAppStore.getState().userInfo;
};
